module.exports = __webpack_public_path__ + "img/checkout-flowers.447ec892.jpeg";